import { initialState } from './reducer';

export const selectTimezone = () => state =>
  (state.currentUser && state.currentUser.preferredTimezone) || null;

export default () => state => state.currentUser || initialState;
